import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);


export default () => {

  const body = document.body;
  const html = document.documentElement;

  //--------------------------------//
  // Contrast toggle functionality 
  //--------------------------------//
  const contrastToggleButton = document.querySelectorAll('.toggle-contrast');

  if (contrastToggleButton) {

    function toggleContrast() {
      html.classList.toggle('high-contrast');
      updateButtons();
      if (html.classList.contains('high-contrast')) {
        localStorage.setItem('highContrastEnabled', 'true');
      } else {
        localStorage.setItem('highContrastEnabled', 'false');
      }
    }

    function updateButtons() {
      if (html.classList.contains('high-contrast')) {
        contrastToggleButton.forEach(button => {
          let textOn = button.dataset.textOn;
          let textOff = button.dataset.textOff;
          button.querySelector('.text').textContent = textOn;
        });
      } else {
        contrastToggleButton.forEach(button => {
          let textOn = button.dataset.textOn;
          let textOff = button.dataset.textOff;
          button.querySelector('.text').textContent = textOff;
        });
      }
    }

    // Check if user has set contrast to more or has enabled it in localStorage
    if (window.matchMedia('(prefers-contrast: more)').matches || localStorage.getItem('highContrastEnabled') === 'true') {
      toggleContrast();
    }

    contrastToggleButton.forEach(button => {
      button.addEventListener('click', () => {
        toggleContrast();
      });
    });
  }
  // END Contrast toggle functionality --------------//

  //--------------------------------//
  // font size toggle functionality 
  //--------------------------------//
  const fontSizeControls = document.querySelectorAll('.font-size-controls');
  const fontSizeClasses = [];

  if (fontSizeControls) {
    // get all buttons
    fontSizeControls.forEach(control => {
      const buttons = control.querySelectorAll('button');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          toggleFontSize(button.dataset.class);
          fontSizeClasses.push(button.dataset.class);
        });
      });
    });
  }

  // function to toggle font size
  function toggleFontSize(className) {
    // remove all other font size classes
    html.classList.remove(...fontSizeClasses);
    html.classList.add(className);
  }
  // END font size --------------//


  //--------------------------------//
  // 🗣️ Reader
  //--------------------------------//

  // ⏯️ Reader controls --------------//
  const readerPauseButton = document.querySelector('#reader-pause');
  const readerNextButton = document.querySelector('#reader-next');
  const readerPreviousButton = document.querySelector('#reader-previous');

  // ⏯️ Pause and resume reader
  readerPauseButton.addEventListener('click', () => {
    if (readerPauseButton.dataset.readerState === 'pause') {
      speechSynthesis.resume();
      readerPauseButton.dataset.readerState = 'resume';
    } else {
      speechSynthesis.pause();
      readerPauseButton.dataset.readerState = 'pause';
    }
  });

  // ⏭️ Next element
  readerNextButton.addEventListener('click', () => {
    // disable button when no next element
    if (elementsToReadIndex >= elementsToRead.length) {
      readerNextButton.disabled = true;
      return;
    }
    readerNext();
  });

  // ⏮️ Previous element
  readerPreviousButton.addEventListener('click', () => {
    readerPrevious();
  });

  const readerToggleButton = document.querySelectorAll('.toggle-reader');

  //--------------------------------//
  // Get elments to read  
  //--------------------------------//
  const elements = document.querySelectorAll('*');
  let elementsToRead = [];
  let elementsToReadIndex = 0;

  // // Helper function to check if element has a class that starts with 'ACF-'
  // function hasACFClass(element) {
  //   return Array.from(element.classList).some(className => className.startsWith('ACF-'));
  // }

  // ! // version 1 Get elements based on headers
  // elements.forEach(element => {
  //   if (element.tagName === 'H1' || element.tagName === 'H2' || element.tagName === 'H3' || element.tagName === 'H4') {
  //     let parent = element.parentElement;
  //     while (!parent.classList.contains('alloy-card') && !hasACFClass(parent) && !parent.classList.contains('alloy-intro')) {
  //       parent = parent.parentElement;
  //       if (parent === null) {
  //         return;
  //       }
  //     }
  //     elementsToRead.push(parent);
  //   }
  // });

  // ! // version 2gets duplicate elements
  // const getElementsToRead = [
  //   'alloy-card',
  //   'alloy-intro',
  // ];
  // elements.forEach(element => {
  //   if (getElementsToRead.some(className => element.classList.contains(className))) {
  //     elementsToRead.push(element);
  //   }
  //   // En ACF-
  //   if (Array.from(element.classList).some(className => className.startsWith('ACF-'))) {
  //     elementsToRead.push(element);
  //   }
  // })

  // // ? Remove alloy-card from list if they are inside ACF-
  // elementsToRead = elementsToRead.filter(element => !element.classList.contains('alloy-card'));
  // // ❌ remove duplicate elements
  // elementsToRead = [...new Set(elementsToRead)];


  // * Version 3 per element
  // get all elmetns that have the class that contains ACF-
  elements.forEach(element => {

    // Get all Flex blocks
    if (Array.from(element.classList).some(className => className.startsWith('ACF-'))) {
      elementsToRead.push(element);
    }
    // Get all .alloy-card elements that are not part of the above flex blocks
    if (element.classList.contains('alloy-card')) {
      let parent = element.parentElement;
      let insideACF = false;
      while (parent) {
        if (Array.from(parent.classList).some(className => className.startsWith('ACF-'))) {
          insideACF = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!insideACF) {
        elementsToRead.push(element);
      }
    }
    // get other elments 
    const otherElementsToRead = [
      'alloy-intro',
      'alloy-overlay',
    ];
    if (otherElementsToRead.some(className => element.classList.contains(className))) {
      elementsToRead.push(element);
    }
  });


  // END Get elments to read  --------------//

  // 🔈 Enable speech synthesis by browser
  let voices = [];

  if (!('speechSynthesis' in window)) {
    alert('Sorry, your browser does not support speech synthesis.');
    document.getElementById('read').disabled = true;
  } else {
    function loadVoices() {
      voices = speechSynthesis.getVoices();
    }
    speechSynthesis.addEventListener('voiceschanged', loadVoices);
    loadVoices();
  }

  // ❌ Disable buttons when no next or previous element
  function setButtonState() {
    if (elementsToReadIndex >= elementsToRead.length - 1) {
      readerNextButton.disabled = true;
    } else {
      readerNextButton.disabled = false;
    }
    if (elementsToReadIndex === 0) {
      readerPreviousButton.disabled = true;
    } else {
      readerPreviousButton.disabled = false;
    }
  }

  // Stop current reader and remove styling
  function readerStop() {
    speechSynthesis.cancel();
    html.classList.remove('reader-active');
    elementsToRead.forEach(element => {
      // element.style.outline = 'none';
      // gsap clear all
      gsap.set(element, {
        outline: 'none',
        outlineOffset: '0px',
      });
    });
  }

  // Automatically read next element when current element is finished
  speechSynthesis.addEventListener("end", (event) => {
    readerNext();
  });

  // ⏮️ Read previous element
  function readerPrevious() {
    readerStop();
    elementsToReadIndex -= 2;
    readerNext();
  }

  // ⏭️ Read next element
  function readerNext() {
    setButtonState();
    readerStop();
    // focus first link element if there is one the elment it self can also be a link
    const element = elementsToRead[elementsToReadIndex];
    if (element.tagName === 'A') {
      element.focus();
    } else {
      const firstLink = element.querySelector('a');
      if (firstLink) {
        firstLink.focus();
      }
    }
    gsap.to(window, {
      scrollTo: {
        y: elementsToRead[elementsToReadIndex].offsetTop,
        offsetY: 100,
        ease: 'none',
      },
      duration: 0.3,
    });
    html.classList.add('reader-active');
    const utterance = new SpeechSynthesisUtterance(elementsToRead[elementsToReadIndex].innerText);
    gsap.to(elementsToRead[elementsToReadIndex], {
      outline: '2px solid red',
      outlineOffset: 10,
      duration: 0.3,
      ease: 'none',
    });
    utterance.voice = voices.find(v => v.lang === 'nl-NL');
    speechSynthesis.cancel();
    speechSynthesis.speak(utterance);
    elementsToReadIndex++;
  }

  // ⏹️ Show/stop reader
  readerToggleButton.forEach(button => {
    button.addEventListener('click', () => {
      if (speechSynthesis.speaking) {
        readerStop();
      } else {
        readerNext();
      }
    });
  });
  // END 🗣️ Reader --------------//
};